import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Refresh';
import styles from './RefreshIcon.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import PropTypes from 'prop-types';

const rootClassName = styles.rootClassName;

class RefreshIcon extends Component {
  render() {
    const props = {
      ...this.props,
      className: getMergedClassNames([
        this.props.static ? '' : rootClassName,
        this.props.className || '',
      ]),
      style: {
        ...(this.props.style || {}),
        color: this.props.currentColor,
      },
    };
    delete props.currentColor;
    return <ComponentIcon {...props} />;
  }
}

RefreshIcon.propTypes = {
  static: PropTypes.bool,
  currentColor: PropTypes.string,
};

export default RefreshIcon;
